export const nextKey = data => {
	const ids = Object.keys(data);
	if (ids.length === 0) return '0';
	const last = ids.reduce(
		(acc, i) => (Number(i) > acc ? Number(i) : acc),
		Number(ids[0])
	);

	return `${Number(last) + 1}`;
};

export const repeat = (count, pattern) => Array(count).fill(pattern).join('');
export const indent = (count, pattern, subject) =>
	`${repeat(count, pattern)}${subject}`.slice(-count);

export const getStatus = itemsList => {
	if (itemsList.length < 1) return 0;
	return itemsList.reduce(
		(acc, item) => (item.status < acc ? item.status : acc),
		2
	);
};

export const format = content => {
	// if (/^update/.test(content)) {
	// 	const contentItems = content.split('~');
	// 	return contentItems.map((item, i) =>
	// 		i % 2 === 1 ? (
	// 			<strong key={String(i)}>{item}</strong>
	// 		) : (
	// 			<span key={String(i)}>{item}</span>
	// 		)
	// 	);
	// }
	if (/^update/.test(content)) {
		return content.replace(/~/g, '')
	}
	if (/^message/.test(content)) {
		return <span>{'message: '}<strong>{content.slice(9)}</strong></span>
	}
	return content;
};
